export enum MediaLink {
    CreateNewMedia,
    ChooseMediaFromLibrary
  }

  export const MediaLinksTranslations = {
    [MediaLink.CreateNewMedia]: 'editEngagement.form.createNewMedia',
    [MediaLink.ChooseMediaFromLibrary]: 'editEngagement.form.chooseMedia'
  };